import { BonusGame } from './bonus_game';
import { NewBonusMessageResolver } from './resolvers/new_bonus_message_resolver';
import { BonusContext, IBonusScene, IConfiguration, INumberFormatter } from '@cgs/common';
import { Func3, CancellationToken } from '@cgs/shared';
import { BonusResponse } from '@cgs/data-access';

export class NewBonusGame extends BonusGame {
  constructor(
    bonusScene: IBonusScene,
    configuration: IConfiguration,
    bonusContext: BonusContext,
    updateBonusFinishPropertiesWithCurrent: Func3<
      BonusResponse,
      Map<string, any>,
      Map<string, any>,
      void
    > | null,
    gameType: string,
    cancellationToken: CancellationToken,
    numberFormatter: INumberFormatter
  ) {
    super(
      bonusScene,
      bonusContext,
      updateBonusFinishPropertiesWithCurrent,
      gameType,
      cancellationToken,
      numberFormatter
    );
    this.bonusMessageResolver = new NewBonusMessageResolver(
      bonusContext,
      updateBonusFinishPropertiesWithCurrent,
      configuration,
      numberFormatter
    );
  }
}
